import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getPossibleNextMacroWizardEdge,
  extractMacroWizardTagPathArray,
  extractSelectedWizardMacro,
  extractNoMatchPageActivated,
  getEscalationMacroList,
  getAllEscalationAlertsForLevel,
} from '../../extractFromState';
import MWNoMatch from './MWNoMatch/MWNoMatch';
import MWSelectOptions from './MWSelectOptions/MWSelectOptions';
import MWList from './MWList/MWList';
import MWResultPage from './MWResultPage/MWResultPage';

export class MacroWizard extends Component {
  // determines if selectOptionsSection should be shown
  showSelectOptionsSection() {
    return !this.props.selectedMacro && this.props.possibleNextPaths.length && !this.props.noMatchPageActivated;
  }

  // determines if macroListSection should be shown
  showMacroListSection() {
    return !this.props.selectedMacro && !!this.props.tagPathArray.length && !this.showSelectOptionsSection();
  }

  render() {
    const { selectedMacro, noMatchPageActivated } = this.props;

    return (
      <>
        {this.showSelectOptionsSection() ? <MWSelectOptions /> : null}
        {this.showMacroListSection() ? <MWList /> : null}
        {selectedMacro && <MWResultPage searchResult={selectedMacro} />}
        {noMatchPageActivated && <MWNoMatch />}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  possibleNextPaths: getPossibleNextMacroWizardEdge(state),
  tagPathArray: extractMacroWizardTagPathArray(state),
  selectedMacro: extractSelectedWizardMacro(state),
  noMatchPageActivated: extractNoMatchPageActivated(state),
  escalationMacroList: getEscalationMacroList(state),
  escalationAlerts: getAllEscalationAlertsForLevel(state),
});

export default connect(mapStateToProps)(MacroWizard);
